import { CGame } from "./CGame";

export class CMJWindShow {
    private m_Parent:fgui.GComponent;
    private m_mc:fgui.GComponent;
	private m_tx:number;
    private m_Game:CGame;

    constructor() {
        this.m_Game = CGame.Instance;
    }

    public attachMCWind(mc:fgui.GComponent):void {
        this.m_Parent = mc;
        this.m_mc = mc.getChild("mc_WindShow") as fgui.GComponent;
        this.m_tx = this.m_mc.x;
    }

    public Set(round:number, wind:number, pCallback:Function = null, v:number = 1):void { 
        var sx:number = -390;
        this.m_mc.visible = true;
        this.m_mc.x = sx;
        let mcC = this.m_mc.getChild("mc_WShow0") as fgui.GMovieClip;
        mcC.visible = true;
        mcC.frame = round;
        mcC = this.m_mc.getChild("mc_WShow1") as fgui.GMovieClip;
        mcC.visible = true;
        mcC.frame = wind;

        this.m_Game.PlayTransition(this.m_Parent, "WindShow", pCallback, v);
    }
}